var _rect, _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueWoodPhoneOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 70,
    viewBox: "0 0 430 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 68,
    transform: "translate(0 1)",
    fill: "#E7EDF4",
    fillOpacity: 0.87
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2726_145)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2726_145)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 180.5V0.5H70V180.5H45ZM67 76.5H57.5H48C48 71.9436 51.8161 64.5 57.5 64.5C63.1839 64.5 67 71.9436 67 76.5ZM48.0001 78.5L57.5001 110.5L67.0001 78.5H48.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 180.5,
    x2: 111.5,
    y2: 0.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.5,
    y1: 180.5,
    x2: 155.5,
    y2: 0.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202 180.5V0.5H227V180.5H202ZM224 76.5H214.5H205C205 71.9436 208.816 64.5 214.5 64.5C220.184 64.5 224 71.9436 224 76.5ZM205 78.5L214.5 110.5L224 78.5H205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.5,
    y1: 180.5,
    x2: 268.5,
    y2: 0.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.5,
    y1: 180.5,
    x2: 312.5,
    y2: 0.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359 180.5V0.5H384V180.5H359ZM381 76.5H371.5H362C362 71.9436 365.816 64.5 371.5 64.5C377.184 64.5 381 71.9436 381 76.5ZM362 78.5L371.5 110.5L381 78.5H362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.5,
    y1: 180.5,
    x2: 425.5,
    y2: 0.5,
    stroke: "white",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 1436,
    height: 16,
    stroke: "white",
    strokeWidth: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.294 33.4375H114.805C114.76 33.1155 114.667 32.8295 114.527 32.5795C114.387 32.3258 114.207 32.1098 113.987 31.9318C113.768 31.7538 113.514 31.6174 113.226 31.5227C112.942 31.428 112.633 31.3807 112.3 31.3807C111.697 31.3807 111.173 31.5303 110.726 31.8295C110.279 32.125 109.932 32.5568 109.686 33.125C109.44 33.6894 109.317 34.375 109.317 35.1818C109.317 36.0114 109.44 36.7083 109.686 37.2727C109.936 37.8371 110.285 38.2633 110.732 38.5511C111.179 38.839 111.696 38.983 112.283 38.983C112.612 38.983 112.917 38.9394 113.197 38.8523C113.482 38.7652 113.733 38.6383 113.953 38.4716C114.173 38.3011 114.355 38.0947 114.499 37.8523C114.646 37.6098 114.749 37.3333 114.805 37.0227L117.294 37.0341C117.23 37.5682 117.069 38.0833 116.811 38.5795C116.557 39.072 116.214 39.5133 115.783 39.9034C115.355 40.2898 114.843 40.5966 114.249 40.8239C113.658 41.0473 112.989 41.1591 112.243 41.1591C111.205 41.1591 110.277 40.9242 109.459 40.4545C108.644 39.9848 108 39.3049 107.527 38.4148C107.057 37.5246 106.822 36.447 106.822 35.1818C106.822 33.9129 107.061 32.8333 107.538 31.9432C108.016 31.053 108.663 30.375 109.482 29.9091C110.3 29.4394 111.22 29.2045 112.243 29.2045C112.917 29.2045 113.542 29.2992 114.118 29.4886C114.697 29.678 115.211 29.9545 115.658 30.3182C116.105 30.678 116.468 31.1193 116.749 31.642C117.033 32.1648 117.214 32.7633 117.294 33.4375ZM129.751 35.1818C129.751 36.4508 129.511 37.5303 129.03 38.4205C128.553 39.3106 127.901 39.9905 127.075 40.4602C126.253 40.9261 125.329 41.1591 124.303 41.1591C123.268 41.1591 122.34 40.9242 121.518 40.4545C120.696 39.9848 120.047 39.3049 119.57 38.4148C119.092 37.5246 118.854 36.447 118.854 35.1818C118.854 33.9129 119.092 32.8333 119.57 31.9432C120.047 31.053 120.696 30.375 121.518 29.9091C122.34 29.4394 123.268 29.2045 124.303 29.2045C125.329 29.2045 126.253 29.4394 127.075 29.9091C127.901 30.375 128.553 31.053 129.03 31.9432C129.511 32.8333 129.751 33.9129 129.751 35.1818ZM127.257 35.1818C127.257 34.3598 127.134 33.6667 126.888 33.1023C126.645 32.5379 126.303 32.1098 125.859 31.8182C125.416 31.5265 124.897 31.3807 124.303 31.3807C123.708 31.3807 123.189 31.5265 122.746 31.8182C122.303 32.1098 121.958 32.5379 121.712 33.1023C121.469 33.6667 121.348 34.3598 121.348 35.1818C121.348 36.0038 121.469 36.697 121.712 37.2614C121.958 37.8258 122.303 38.2538 122.746 38.5455C123.189 38.8371 123.708 38.983 124.303 38.983C124.897 38.983 125.416 38.8371 125.859 38.5455C126.303 38.2538 126.645 37.8258 126.888 37.2614C127.134 36.697 127.257 36.0038 127.257 35.1818ZM131.574 29.3636H134.608L137.812 37.1818H137.949L141.153 29.3636H144.188V41H141.801V33.4261H141.705L138.693 40.9432H137.068L134.057 33.3977H133.96V41H131.574V29.3636ZM146.214 29.3636H149.249L152.453 37.1818H152.589L155.794 29.3636H158.828V41H156.442V33.4261H156.345L153.334 40.9432H151.709L148.697 33.3977H148.601V41H146.214V29.3636ZM163.315 29.3636V41H160.855V29.3636H163.315ZM164.896 31.392V29.3636H174.453V31.392H170.891V41H168.459V31.392H164.896ZM176.027 29.3636H179.061L182.266 37.1818H182.402L185.607 29.3636H188.641V41H186.254V33.4261H186.158L183.146 40.9432H181.521L178.51 33.3977H178.413V41H176.027V29.3636ZM190.668 41V29.3636H198.509V31.392H193.128V34.1648H198.105V36.1932H193.128V38.9716H198.531V41H190.668ZM210.197 29.3636V41H208.072L203.01 33.6761H202.925V41H200.464V29.3636H202.624L207.646 36.6818H207.749V29.3636H210.197ZM211.787 31.392V29.3636H221.344V31.392H217.781V41H215.349V31.392H211.787ZM226.178 31.392V29.3636H235.734V31.392H232.172V41H229.74V31.392H226.178ZM247.47 35.1818C247.47 36.4508 247.23 37.5303 246.749 38.4205C246.271 39.3106 245.62 39.9905 244.794 40.4602C243.972 40.9261 243.048 41.1591 242.021 41.1591C240.987 41.1591 240.059 40.9242 239.237 40.4545C238.415 39.9848 237.766 39.3049 237.288 38.4148C236.811 37.5246 236.572 36.447 236.572 35.1818C236.572 33.9129 236.811 32.8333 237.288 31.9432C237.766 31.053 238.415 30.375 239.237 29.9091C240.059 29.4394 240.987 29.2045 242.021 29.2045C243.048 29.2045 243.972 29.4394 244.794 29.9091C245.62 30.375 246.271 31.053 246.749 31.9432C247.23 32.8333 247.47 33.9129 247.47 35.1818ZM244.976 35.1818C244.976 34.3598 244.853 33.6667 244.607 33.1023C244.364 32.5379 244.021 32.1098 243.578 31.8182C243.135 31.5265 242.616 31.3807 242.021 31.3807C241.427 31.3807 240.908 31.5265 240.464 31.8182C240.021 32.1098 239.677 32.5379 239.43 33.1023C239.188 33.6667 239.067 34.3598 239.067 35.1818C239.067 36.0038 239.188 36.697 239.43 37.2614C239.677 37.8258 240.021 38.2538 240.464 38.5455C240.908 38.8371 241.427 38.983 242.021 38.983C242.616 38.983 243.135 38.8371 243.578 38.5455C244.021 38.2538 244.364 37.8258 244.607 37.2614C244.853 36.697 244.976 36.0038 244.976 35.1818ZM257.388 36.9545H259.479L260.53 38.3068L261.564 39.5114L263.513 41.9545H261.217L259.876 40.3068L259.189 39.3295L257.388 36.9545ZM263.689 35.1818C263.689 36.4508 263.448 37.5303 262.967 38.4205C262.49 39.3106 261.839 39.9905 261.013 40.4602C260.191 40.9261 259.267 41.1591 258.24 41.1591C257.206 41.1591 256.278 40.9242 255.456 40.4545C254.634 39.9848 253.984 39.3049 253.507 38.4148C253.03 37.5246 252.791 36.447 252.791 35.1818C252.791 33.9129 253.03 32.8333 253.507 31.9432C253.984 31.053 254.634 30.375 255.456 29.9091C256.278 29.4394 257.206 29.2045 258.24 29.2045C259.267 29.2045 260.191 29.4394 261.013 29.9091C261.839 30.375 262.49 31.053 262.967 31.9432C263.448 32.8333 263.689 33.9129 263.689 35.1818ZM261.195 35.1818C261.195 34.3598 261.071 33.6667 260.825 33.1023C260.583 32.5379 260.24 32.1098 259.797 31.8182C259.354 31.5265 258.835 31.3807 258.24 31.3807C257.645 31.3807 257.126 31.5265 256.683 31.8182C256.24 32.1098 255.895 32.5379 255.649 33.1023C255.407 33.6667 255.286 34.3598 255.286 35.1818C255.286 36.0038 255.407 36.697 255.649 37.2614C255.895 37.8258 256.24 38.2538 256.683 38.5455C257.126 38.8371 257.645 38.983 258.24 38.983C258.835 38.983 259.354 38.8371 259.797 38.5455C260.24 38.2538 260.583 37.8258 260.825 37.2614C261.071 36.697 261.195 36.0038 261.195 35.1818ZM272.699 29.3636H275.159V36.9205C275.159 37.7689 274.956 38.5114 274.551 39.1477C274.15 39.7841 273.587 40.2803 272.864 40.6364C272.14 40.9886 271.297 41.1648 270.335 41.1648C269.369 41.1648 268.525 40.9886 267.801 40.6364C267.078 40.2803 266.515 39.7841 266.114 39.1477C265.712 38.5114 265.511 37.7689 265.511 36.9205V29.3636H267.972V36.7102C267.972 37.1534 268.068 37.5473 268.261 37.892C268.458 38.2367 268.735 38.5076 269.091 38.7045C269.447 38.9015 269.862 39 270.335 39C270.813 39 271.227 38.9015 271.58 38.7045C271.936 38.5076 272.21 38.2367 272.403 37.892C272.6 37.5473 272.699 37.1534 272.699 36.7102V29.3636ZM279.189 41H276.553L280.57 29.3636H283.74L287.751 41H285.115L282.2 32.0227H282.109L279.189 41ZM279.024 36.4261H285.251V38.3466H279.024V36.4261ZM289.152 41V29.3636H291.612V38.9716H296.601V41H289.152ZM300.69 29.3636V41H298.23V29.3636H300.69ZM302.271 31.392V29.3636H311.828V31.392H308.266V41H305.834V31.392H302.271ZM312.72 29.3636H315.476L318.129 34.375H318.243L320.896 29.3636H323.652L319.408 36.8864V41H316.964V36.8864L312.72 29.3636Z",
    fill: "#A7A9AC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2726_145)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2726_145)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 230.5V50.5H70V230.5H45ZM67 126.5H57.5H48C48 121.944 51.8161 114.5 57.5 114.5C63.1839 114.5 67 121.944 67 126.5ZM48.0001 128.5L57.5001 160.5L67.0001 128.5H48.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 230.5,
    x2: 111.5,
    y2: 50.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.5,
    y1: 230.5,
    x2: 155.5,
    y2: 50.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202 230.5V50.5H227V230.5H202ZM224 126.5H214.5H205C205 121.944 208.816 114.5 214.5 114.5C220.184 114.5 224 121.944 224 126.5ZM205 128.5L214.5 160.5L224 128.5H205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.5,
    y1: 230.5,
    x2: 268.5,
    y2: 50.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.5,
    y1: 230.5,
    x2: 312.5,
    y2: 50.5,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359 230.5V50.5H384V230.5H359ZM381 126.5H371.5H362C362 121.944 365.816 114.5 371.5 114.5C377.184 114.5 381 121.944 381 126.5ZM362 128.5L371.5 160.5L381 128.5H362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.5,
    y1: 230.5,
    x2: 425.5,
    y2: 50.5,
    stroke: "white",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 52.5,
    width: 1436,
    height: 16,
    stroke: "white",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2726_145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2726_145"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 1440,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2726_145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 20,
    fill: "white",
    transform: "translate(0 50)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2726_145"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 50.5,
    width: 1440,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWoodPhoneOriginal);
export default __webpack_public_path__ + "static/media/blueWoodPhoneOriginal.5fee25360e0d0922e57c0eb0368d9e1b.svg";
export { ForwardRef as ReactComponent };